<jw-modal id="vorModal">
  <h1 class='header'>Vehicle VORs and Driver Absence</h1>

  Below lists all today's VORs and driver absence
  <br />
  <br />
  <br />
  <div class='' style='display:flex; flex-flow: row wrap;'>
    <div>
      <h2>Vehicle VORs</h2>

      <ul>
        @if (this.data.vor.length > 0) {
          @for (item of this.data.vor; track item) {
            <li>
              {{ item.vehicle.registration }} - {{ item.notes }} - (<span style='color:red;font-weight: bold;'>Back on road {{ getAbsenceEnd(item.endDate) }}</span>)
            </li>
          }
        }
        @if (this.data.vor.length === 0) {
          <li>No VORs for today</li>
        }
      </ul>

    </div>

    <div style='margin-left: 3rem;'>
      <h2>Driver Absence</h2>
      <ul>
        @if (this.data.absence.length === 0) {
          <li>No absence for today</li>
        }
        @if (this.data.absence.length > 0) {
          @for (item of this.data.absence; track item) {
            <li>
              {{ item.driver.firstName }} {{ item.driver.lastName }} - {{ item.notes }}  (<span style='color:red;font-weight: bold;'>Returns {{ getAbsenceEnd(item.endDate) }}</span>)
            </li>
          }
        }
      </ul>


    </div>
  </div>
  <button class='btn btn-primary' (click)='this.close()'>Close</button> &nbsp;&nbsp;
</jw-modal>
